import { get } from 'lodash';

export const isInitialLoadSelector = state => get( state, 'uiState.isInitialLoad', false );
export const isExperimentalSelector = state => get( state, 'uiState.isExperimental', false );
export const isEditModeSelector = state => get( state, 'uiState.isEditMode', false );

// Login
export const isSessionValidSelector = state => get( state, 'auth.isSessionValid', false );
export const createSessionInFlightSelector = state => get( state, 'auth.createSessionInFlight', false );
export const loginErrorSelector = state => get( state, 'uiState.loginError', false );
export const loginStatusSelector = state => get( state, 'uiState.loginStatus', false );

// Navigation
export const selectedSideNavItemIdSelector = state => get( state, 'uiState.selectedSideNavId', [] );
export const sideNavItemsSelector = state => get( state, 'uiState.sideNavItems', [] );

export const isMaintenanceFlagSelector = state => get( state, 'uiState.featureFlags.maintenance', false );
